module.exports = __webpack_public_path__ + "img/010-fairytale.178e7da7.svg";